import { LOCAL_STORAGE_KEYS } from "../../../../helpers/utils/Constants/keys";
import { roles } from "../../../../helpers/utils/Constants/roles";

export const getSlugByUsingUserRole = (role: string) => {
  if (role === "user") {
    return "tour-video";
  }
  if (
    role === roles.SELF_PACED_SCRUM_MASTER_STUDENT ||
    role === roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT
  ) {
    return "self-paced-scrum-master-onboarding-video";
  }
  if (role === roles.SELF_PACED_PRODUCT_MANAGER_STUDENT) {
    return "self-paced-product-manager-onboarding-video";
  }
  return "tour-video";
};

export const getRoleValue = (
  role: string,
  authState?: any,
  multipleRole: boolean = false
): string => {
  const allRoles: string[] = authState?.tac_user?.all_roles || [];
  const roleByLocalStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TYPE);
  if (multipleRole && roleByLocalStorage) {
    return roleByLocalStorage;
  }
  if (allRoles.includes(roles.AI_BUSINESS_ANALYST_STUDENT)) {
    // ✅ Handle AI Business Analyst inside all_roles
    return "ai_business_analyst";
  }

  // ✅ Self-paced roles
  if (role === roles.SELF_PACED_SCRUM_MASTER_STUDENT) {
    return "self_paced_scrum_master";
  }

  if (role === roles.SELF_PACED_PRODUCT_OWNER_STUDENT) {
    return "self_paced_product_owner";
  }

  if (role === roles.SELF_PACED_BUSINESS_ANALYST_STUDENT) {
    return "self_paced_business_analyst";
  }

  if (role === roles.SELF_PACED_PRODUCT_MANAGER_STUDENT) {
    return "self_paced_product_manager";
  }

  if (role === roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT) {
    return "self_paced_agile_project_manager";
  }

  if (role === roles.AA_ICP_CERTIFCATION) {
    return "aa_icp_certification";
  }
  if (role === roles.AA_ICP_PDM_CERTIFCATION) {
    return "aa_icp_pdm_certification";
  }

  // ✅ Default user role (only if not AI BA)
  if (role === "user") {
    return "user_dashboard";
  }

  // ✅ Fallback
  return "user_dashboard";
};
